import React from "react";
import BackButton from ".";

interface BackButtonWrapperProps {
  children: React.ReactNode;
  isDarkModeStyles?: boolean;
}

const BackButtonWrapper = ({ children,
  isDarkModeStyles = true,

}: BackButtonWrapperProps) => {
  return (
    <div className="flex items-center gap-1 sm:gap-2 justify-between">
      {children}

      <BackButton isDarkModeStyles={isDarkModeStyles} />
    </div>
  );
};

export default React.memo(BackButtonWrapper);
